import { render, staticRenderFns } from "./bom-order.vue?vue&type=template&id=4eafed7c&"
import script from "./bom-order.vue?vue&type=script&lang=js&"
export * from "./bom-order.vue?vue&type=script&lang=js&"
import style0 from "./bom-order.vue?vue&type=style&index=0&id=4eafed7c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports